import React from "react";

import { useSelector } from "react-redux";
import { HashRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ConfirmProvider } from "material-ui-confirm";
import { QueryClientProvider, QueryClient } from "react-query";
import { QueryParamProvider } from "use-query-params";

import PrivateRoute from "./Components/PrivateRoute";
import Loading from "./Components/Loading";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import LoginPage from "./Views/Login";
import SignInPage from "./Views/SignIn";
import ChangePassword from "./Views/ChangePassword";

import Routes from "./Routes";

const queryClient = new QueryClient();

function App() {
  const { isLoading } = useSelector((state) => state.store);

  return (
    <div className="app">
      <HashRouter>
        <ConfirmProvider>
          <QueryClientProvider client={queryClient}>
            <QueryParamProvider ReactRouterRoute={Route}>
              <Switch>
                <Route exact path="/login" component={LoginPage} />
                <Route path="/sign-in" component={SignInPage} />
                <Route path="/change-password" component={ChangePassword} />
                <PrivateRoute path="/" component={Routes} />
              </Switch>
            </QueryParamProvider>
          </QueryClientProvider>
        </ConfirmProvider>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar={false}
        />
        {isLoading && (
          <div id="loading">
            <Loading />
          </div>
        )}
      </HashRouter>
    </div>
  );
}

export default App;
